const data = [
    'Melissa Miller',
    'Jasmine Simpson',
    'Stacy Sanchez',
    'William Hart',
    'Brian Montgomery',
    'Traci Donaldson',
    'Carolyn Robinson',
    'Dr. Stephanie Allen',
    'Christina Crosby',
    'Melissa Adams',
    'Chase Russell',
    'Barbara Reed',
    'Elizabeth Hernandez',
    'Beverly Jarvis',
    'David Franklin',
    'Martha Harper',
    'Amanda Everett',
    'Anna Wood MD',
    'Morgan Nash',
    'Michael Jones',
    'Theresa Newman',
    'Steven Lewis',
    'William Garcia',
    'Brandon Russell',
    'Sean Morton',
    'Jacob Ochoa',
    'Kim Novak',
    'Angela Skinner',
    'Melissa Phillips',
    'Allison Cruz',
    'Mario Bennett',
    'Cody Bowman',
    'Tracie Strickland',
    'Ashley Anderson',
    'Joshua Hill',
    'Donald Hampton',
    'Melissa Hickman',
    'Jenna Lawson',
    'Mason Rodriguez',
    'Latasha Richardson',
    'Jeffery Guerrero',
    'Dylan Schultz',
    'Stephanie Miller',
    'Donna Henderson',
    'Ashley King',
    'Debra Macdonald DDS',
    'Sandra Sanchez',
    'Ralph Allen',
    'Elizabeth Castillo',
    'Matthew Rogers',
    'Robert Burns',
    'Tara Barr',
    'Douglas Parrish',
    'Kimberly Gonzalez',
    'Anthony Newman',
    'Teresa Lopez',
    'Kelly Jones',
    'Tyler Garcia',
    'Shannon Pierce',
    'Christopher Mason',
    'Olivia May',
    'Shane Moore',
    'Emily Smith',
    'Dustin Cole',
    'Shaun Griffith',
    'Kendra Richmond',
    'Sean Wilson',
    'Christopher Avila',
    'Kylie Campbell',
    'Alison Cruz',
    'Sean Navarro',
    'Jennifer Smith',
    'Keith Dillon',
    'Justin Fuller',
    'Kyle Smith',
    'Alicia Bell',
    'Elizabeth Morse',
    'Nicholas Acevedo',
    'Lindsay Park',
    'Jacob Diaz',
    'Dr. Christopher Aguirre',
    'Paula Kelley',
    'Paige Rivera',
    'Rebekah Roberts',
    'Monica Beck',
    'Pamela Roberts',
    'Brandon Garcia',
    'Savannah Ballard',
    'Kaitlin Williams MD',
    'William Cooper',
    'Nancy Cole',
    'Tracey Santana',
    'James Lopez',
    'John Chapman',
    'Emily Camacho',
    'Mrs. Jamie Austin PhD',
    'Dawn Hawkins',
    'Scott Mitchell',
    'Ryan Norris',
    'Robert Thompson'
];

export const fetchPrefixMatches = (compareString: string) => {
    const matchList = data.filter((str) => {
        return str.toLowerCase().startsWith(compareString.toLowerCase());
    });

    if (matchList.length === 0) {
        return [compareString];
    }

    return matchList;
};
